import { Amplify } from 'aws-amplify';

/**
 * Configures Amplify Auth against the already-provisioned Cognito User Pool
 * (contract-entry-api-cognito-dev), federated to Salesforce via SAML.
 */
export const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN,
            redirectSignIn: [import.meta.env.VITE_COGNITO_REDIRECT_URI],
            redirectSignOut: [import.meta.env.VITE_COGNITO_LOGOUT_URI],
            responseType: 'code',
            scopes: import.meta.env.VITE_COGNITO_SCOPE.split(' '),
          },
        },
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      },
    },
  });
};
